import {Route, Routes} from 'react-router-dom'
import {Distributors} from './Distributors'
import {Distributor} from './Distributor'
import {Resellers} from 'modules/reseller/Resellers'
import {Reseller} from 'modules/reseller/Reseller'
import {Businesses} from 'modules/business/Businesses'
import {Business} from 'modules/business/Business'
import {Device} from 'modules/device/Device'
import {DeviceTypes, Modes} from 'utility/utility'
import { Group } from 'modules/group/Group'

export const DistributorRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Distributors />} />
      <Route path="/:distributor" element={<Distributor />} />
      <Route path="/:distributor/reseller" element={<Resellers />} />
      <Route path="/:distributor/reseller/:reseller" element={<Reseller />} />
      <Route path="/:distributor/reseller/:reseller/business" element={<Businesses />} />
      <Route
        path="/:distributor/reseller/:reseller/business/create/*"
        element={<Business mode={Modes.CREATE} />}
      />
      <Route
        path="/:distributor/reseller/:reseller/business/:business"
        element={<Business mode={Modes.UPDATE} />}
      />
      <Route
        path="/:distributor/reseller/:reseller/business/:business/device/:type/:mode/:device?/:user?"
        element={<Device />}
      />

      <Route path="/:distributor/reseller/:reseller/business/:business/group/:group" element={<Group />} />

      <Route path="/:distributor/business" element={<Businesses />} />
      <Route path="/:distributor/business/:business" element={<Business />} />

      <Route
        path={`/:distributor/reseller/:reseller/business/:business/${DeviceTypes.OFFICE}/create`}
        element={<Device office />}
      />
      <Route
        path={`/:distributor/reseller/:reseller/business/:business/${DeviceTypes.OFFICE}/update/:device`}
        element={<Device office update />}
      />
      <Route
        path={`/:distributor/reseller/:reseller/business/:business/${DeviceTypes.REMOTE}/create/:user`}
        element={<Device />}
      />
      <Route
        path={`/:distributor/reseller/:reseller/business/:business/${DeviceTypes.REMOTE}/update/:user/:device`}
        element={<Device update />}
      />
    </Routes>
  )
}
